import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetType } from '../base/widget/WidgetTypes'

export const WidgetDirectMessages: Widget = {
  type: WidgetType.directMessages,
  title: 'Direktnachrichten',
  minSize: 2,
  defaultSize: 32,
  icon: 'MessageTextOutline',
  customSettings: {
    settings: {
      showTitle: { type: WidgetSettingType.checkbox, title: 'Widget Titel anzeigen', checked: false },
      unreadonly: { type: WidgetSettingType.checkbox, title: 'Nur ungelesene Nachrichten', checked: false }
    },
    sections: [
      {
        label: 'Filter',
        settings: ['unreadonly']
      }
    ]
  }
}

export default WidgetDirectMessages
